import React, { createContext, useMemo } from 'react';
export function createToggleContext() {
    return createContext(null);
}
export const ToggleButtonContext = createToggleContext();
export const ToggleButtonProvider = (props) => {
    const { children, ...rest } = props;
    const contextValue = useMemo(() => ({ ...rest }), [rest]);
    return React.createElement(ToggleButtonContext.Provider, { value: contextValue }, children);
};
ToggleButtonProvider.displayName = 'ToggleButtonProvider';
